<template>
  <div class="verification">
    <div class="icon">
      <img
        src="@/assets/images/icons/survey-done-check.svg"
        alt="surveyCheck"
      />
    </div>
    <div class="verification-text">
      <span>Ankete katıldığınız için <br />teşekkür ederiz. </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SurveyVerification",
  props: {
    showResultText: Boolean,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

.verification {
  width: 100%;
  min-height: 334px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &-text {
    span {
      margin-top: 12px;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: -0.05px;
      text-align: center;
      color: $colorN80;
      display: flex;
    }
  }

  &-footer {
    margin-top: 24px;
    cursor: pointer;

    span {
      font-size: 16px;
      font-weight: 600;
      letter-spacing: -0.11px;
      color: $blue-5;
    }
  }
}
</style>
